import type { Namespace, TFunction } from 'i18next'

export const mockTBuilder = <Ns extends Namespace>() =>
  ((key: string) => key) as TFunction<Ns>
